import React, { ReactNode } from "react"
import { Box, BoxProps } from "@mui/material"
import Text from "./Text"

interface Props extends BoxProps {
  img?: string
  content: ReactNode
}

const InfoSection: React.FC<Props> = ({ img, content, ...props }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      border="0.75px solid white"
      borderRadius="10px"
      padding="12px"
      {...props}
    >
      {img && (
        <img
          src={img}
          alt="pie chart icon"
          height={22}
          style={{ marginRight: 15 }}
        />
      )}
      <Text size="small">{content}</Text>
    </Box>
  )
}

export default InfoSection
